import React from "react";
import ContactForm from "./ContactForm";
import GoogleMapStyle from "./GoogleMapStyle";
import { FiHeadphones, FiMail, FiMapPin } from "react-icons/fi";

const ContactOne = () => {
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Kontakt Telefon-Nummer</h4>
                                        <p>
                                            <br /> &nbsp;
                                            <a href="tel:+444 555 666 777">+49 221 79002838</a>
                                            <br /> &nbsp;
                                            <br /> &nbsp;
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Unser email-Kontakt</h4>
                                        <p>
                                            <br /> &nbsp;
                                            <a href="mailto:info@embres.de">info@embres.de</a>
                                            <br /> &nbsp;
                                            <br /> &nbsp;
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Unser Büro</h4>
                                        <p>
                                            embres GmbH <br />
                                            Dresenhofweg 62 <br /> 50765 Köln <br />
                                            Deutschland
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row mt--40 row--15">
                <div className="col-lg-7">
                    <ContactForm formStyle="contact-form-1" />
                </div>
                <div className="col-lg-5 mt_md--30 mt_sm--30">
                    <GoogleMapStyle />
                </div>
            </div> */}
        </>
    );
};
export default ContactOne;
